'use strict';
import * as $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner from "./com.raquo.airstream.ownership.-Owner.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$(outer) {
  this.Fr = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__$init$__V(this);
}
export { $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
$p = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$;
/** @constructor */
function $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$() {
}
export { $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
$h_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$.prototype = $p;
$p.ro = (function() {
  return this.Fr;
});
$p.Oc = (function(x$0) {
  this.Fr = x$0;
});
$p.Px = (function() {
  $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__killSubscriptions__V(this);
});
$p.PP = (function(subscription) {
  $j_com$002eraquo$002eairstream$002eownership$002e$002dOwner.$f_Lcom_raquo_airstream_ownership_Owner__own__Lcom_raquo_airstream_ownership_Subscription__V(this, subscription);
});
var $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$, "com.raquo.laminar.api.Laminar$unsafeWindowOwner$", ({
  hB: 1,
  cR: 1
}));
export { $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ as $d_Lcom_raquo_laminar_api_Laminar$unsafeWindowOwner$ };
